<template>
  <v-form ref="form" v-bind="this.$attrs">
    <p class="font-weight-black black--text">7. Thông tin tài khoản ngân hàng</p>
    <v-row class="pr-12">
      <v-col class="d-flex align-center py-0" cols="12">
        <v-subheader class="py-0 px-0">Ngân hàng</v-subheader>
        <p class="mb-0">{{teacher.data.teachBankAccount && teacher.data.teachBankAccount.bankName}}</p>
      </v-col>
      <v-col class="d-flex align-center py-0" cols="12">
        <v-subheader class="px-0">Số tài khoản</v-subheader>
        <p class="mb-0">{{teacher.data.teachBankAccount && teacher.data.teachBankAccount.accountNumber}}</p>
      </v-col>
      <v-col class="py-0 align-center d-flex" cols="12">
        <v-subheader class="px-0">Tên tài khoản</v-subheader>
        <p class="mb-0">{{teacher.data.teachBankAccount && teacher.data.teachBankAccount.accountHolder}}</p>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('teacher', ['teacher'])
  }
}
</script>
<style scoped>
.v-subheader {
  width: 30%;
}
p {
  color: black;
}
.p > .v-input__control > .v-input__slot:before {
  border-style: none;
}
</style>
